import React, { useEffect, useState, useLayoutEffect } from "react";
import { Table, CardBody, Col, CardHeader, Row, Card } from "reactstrap";
import logoDark from "../../../assets/images/logo-dark.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";

const PrintDoc = ({ innerRef, item, type }) => {
  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <Card>
          <Col lg={12}>
            <CardHeader className="border-bottom-dashed p-4">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <img src={logoDark} className="card-logo card-logo-dark" alt="logo dark" height="40" />
                  {/* <img src={logoLight} className="card-logo card-logo-light" alt="logo light" height="40" /> */}
                  <div className="mt-sm-3 mt-3">
                    <h6 className="text-uppercase fs-15 fw-semibold">{item?.purchase_client?.name}</h6>
                    <p className="mb-1 fw-semibold">{item?.purchase_company?.name}</p>
                    <p className="mb-1 fw-semibold">{item?.purchase_branch?.name}</p>
                    {/* <h6 className="text-uppercase fw-semibold">{info.item_company && info.item_company.name}</h6>
                    <p className="mb-1">{info.item_department && info.item_department.name}</p> */}
                  </div>
                </div>
              </div>
            </CardHeader>
            <CardBody className="p-4">
              <Row className="g-3">
                <Col lg={12} xs={12}>
                  <p className="text-muted mb-2 text-uppercase fw-semibold">Tanggal</p>
                  <h5 className="fs-14 mb-0">
                    <span id="invoice-date">{handleValidDate(item.transactionat)}</span>
                  </h5>
                </Col>
              </Row>
            </CardBody>
            <CardBody className="p-4">
              <div>
                <Table className="table-borderless text-center table-nowrap align-middle mb-0">
                  <thead>
                    <tr className="table-active">
                      <th scope="col" style={{ width: "50px" }}>
                        #
                      </th>
                      <th scope="col">Detail Produk</th>
                      <th scope="col">Jumlah Pesanan</th>
                      <th scope="col">Jumlah Penerimaan Barang</th>
                    </tr>
                  </thead>
                  <tbody id="products-list">
                    {(item.purchase_detail || item.transfer_detail || []).map((o, i) => {
                      return (
                        <tr key={o.id} id={o.id} className="product">
                          <th scope="row" className="product-id">{i + 1}</th>
                          <td className="text-start">{o.name}</td>
                          <td>{o.quantity}</td>
                          <td>{o.accepted}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>
              <div className="mt-4">
                <div className="alert alert-info">
                  <p className="mb-0">
                    <span className="fw-semibold">NOTES:</span>
                    <span id="note"> {item.description}</span>
                  </p>
                </div>
              </div>
              <div className="mt-4">
                <div>
                  <p className="mb-0">{item.user}</p>
                </div>
              </div>
            </CardBody>
          </Col>
        </Card>
      </div>
    </div>
  );
};

export default PrintDoc;
